import BaseSessionStorageState from './base-session-storage-state';

export const KEYS = {
  SHOW_FILTERS: 'showFilters',
  SEARCH: 'search',
  JOB_TITLE: 'jobTitle',
  LANGUAGE: 'language',
  // "I'm very good at"
  SERVICE_CATEGORY: 'serviceCategory',
  // "I serve"
  SERVICE_GROUP: 'serviceGroup',
  MAX_DISPLAYS: 'maxDisplays',
  MAX_DISPLAYS_ONLINE_PERSONS: 'maxDisplays.onlinePersons',
  MAX_DISPLAYS_OFFLINE_PERSONS: 'maxDisplays.offlinePersons',
  MAX_DISPLAYS_OTHER_PERSONS: 'maxDisplays.otherPersons',
  MAX_DISPLAYS_FAVOURITE_PERSONS: 'maxDisplays.favouritePersons',
};

const MAX_PERSONS_TO_DISPLAY_INIT = 9;

class ReservationFilterState extends BaseSessionStorageState {
  constructor($log, $sessionStorage) {
    super($log, $sessionStorage)
    this.storageName = 'personSearch';
    const initialState = Object.assign(this.getDefaults(), $sessionStorage[this.storageName]);
    this.$sessionStorage[this.storageName] = initialState;
  }

  getDefaults() {
    return {
      showFilters: false,
      search: "",
      jobTitle: 0,
      language: 0,
      // "I'm very good at"
      serviceCategory: 0,
      // "I serve"
      serviceGroup: 0,
      maxDisplays: {
        onlinePersons: MAX_PERSONS_TO_DISPLAY_INIT,
        offlinePersons: MAX_PERSONS_TO_DISPLAY_INIT,
        otherPersons: MAX_PERSONS_TO_DISPLAY_INIT,
        favouritePersons: MAX_PERSONS_TO_DISPLAY_INIT
      }
    };

  }
}

export default ReservationFilterState;
